import { Select, Tooltip } from 'antd';

export default function ManagerDashboardFilterSelectors({
  financialYearsLoading,
  selectedFinancialYear,
  handleSearch,
  getFinancialYears,
  financialYearsData,
  handleChange,
  setSelectedFinancialYear,
  quarterListLoading,
  selectedQuarters,
  quarterListData,
  setSelectedQuarters,
  projectListLoading,
  projectListData,
  projectListDataWithoutQuarterly,
  projectListLoadingWithoutQuarterly,
  selectedProjectsCode,
  setSelectedProjectsCode,
  selectedProjectsName,
  setSelectedProjectsName,
  selectedProjectsCodeWithoutQuarterly,
  setSelectedProjectsCodeWithoutQuarterly,
  getProjectList,
  loadProjectNames,
  getProjectListWithoutQuarterly,
}) {
  return (
    <div className="flex flex-col">
      {/* .........................financial year........................................................ */}
      <div className="bg-white rounded-md mb-2.5 text-[#1C4E9D] font-medium px-1 py-1 text-xs xl:text-sm font-['SF-Pro-Text-Regular, sans-serif']">
        <Select
          placeholder="Select Financial Year"
          loading={financialYearsLoading}
          variant="borderless"
          mode="multiple"
          style={{ width: '100%' }}
          maxTagCount={1}
          value={selectedFinancialYear}
          onSearch={(v) => handleSearch(v, getFinancialYears)}
          options={[
            { label: 'All', value: 'all' },
            ...financialYearsData.map((yr) => ({
              label: yr,
              value: yr,
            })),
          ]}
          popupMatchSelectWidth={false}
          tagRender={(v) => <span className="text-[#1C4E9D]">{v.label}</span>}
          onChange={(val) =>
            handleChange(val, setSelectedFinancialYear, financialYearsData)
          }
          maxTagPlaceholder={(omittedValues) =>
            selectedFinancialYear.includes('all') ? null : (
              <Tooltip
                styles={{
                  root: {
                    pointerEvents: 'none',
                  },
                }}
                title={omittedValues.map(({ label }) => label).join(', ')}
              >
                <span className="ml-1">{omittedValues.length}+</span>
              </Tooltip>
            )
          }
        />
      </div>

      {/* .........................quarter........................................................ */}
      <div className="bg-white rounded-md mb-6 text-[#1C4E9D] font-medium px-1 py-1 text-xs xl:text-sm font-['SF-Pro-Text-Regular, sans-serif']">
        <Select
          placeholder="Select Quarter"
          loading={quarterListLoading}
          variant="borderless"
          mode="multiple"
          style={{ width: '100%' }}
          maxTagCount={1}
          value={selectedQuarters}
          options={[
            { label: 'All', value: 'all' },
            ...quarterListData.map((yr) => ({
              label: yr,
              value: yr,
            })),
          ]}
          popupMatchSelectWidth={false}
          tagRender={(v) => <span className="text-[#1C4E9D]">{v.label}</span>}
          onChange={(val) =>
            handleChange(val, setSelectedQuarters, quarterListData)
          }
          maxTagPlaceholder={(omittedValues) =>
            selectedQuarters.includes('all') ? null : (
              <Tooltip
                styles={{
                  root: {
                    pointerEvents: 'none',
                  },
                }}
                title={omittedValues.map(({ label }) => label).join(', ')}
              >
                <span className="ml-1">{omittedValues.length}+</span>
              </Tooltip>
            )
          }
        />
      </div>

      {/* .........................Project Code........................................................ */}
      <div className="bg-white rounded-md text-[#1C4E9D] font-medium px-1 py-1 text-xs xl:text-sm font-['SF-Pro-Text-Regular, sans-serif']">
        <Select
          placeholder="Project Code (With Quarterly)"
          loading={projectListLoading}
          variant="borderless"
          mode="multiple"
          style={{ width: '100%' }}
          maxTagCount={1}
          value={selectedProjectsCode}
          onSearch={(v) => handleSearch(v, selectedProjectsCode)}
          options={[
            { label: 'All', value: 'all' },
            ...projectListData.map((yr) => ({
              label: yr.project_code,
              value: yr.project_code,
            })),
          ]}
          popupMatchSelectWidth={false}
          tagRender={(v) => <span className="text-[#1C4E9D]">{v.label}</span>}
          onChange={(val) =>
            handleChange(
              val,
              setSelectedProjectsCode,
              projectListData.map((v) => v.project_code),
            )
          }
          maxTagPlaceholder={(omittedValues) =>
            selectedProjectsCode.includes('all') ? null : (
              <Tooltip
                styles={{
                  root: {
                    pointerEvents: 'none',
                  },
                }}
                title={omittedValues.map(({ label }) => label).join(', ')}
              >
                <span className="ml-1">{omittedValues.length}+</span>
              </Tooltip>
            )
          }
        />
      </div>

      {/* .........................Project Code Without Quarterly submission........................................................ */}
      <div className="bg-white rounded-md text-[#1C4E9D] font-medium px-1 py-1 text-xs xl:text-sm font-['SF-Pro-Text-Regular, sans-serif']">
        <Select
          placeholder="Project Code (Without Quarterly)"
          loading={projectListLoadingWithoutQuarterly}
          variant="borderless"
          mode="multiple"
          style={{ width: '100%' }}
          maxTagCount={1}
          value={selectedProjectsCodeWithoutQuarterly}
          onSearch={(v) =>
            handleSearch(v, selectedProjectsCodeWithoutQuarterly)
          }
          options={[
            { label: 'All', value: 'all' },
            ...projectListDataWithoutQuarterly.map((yr) => ({
              label: yr.project_code,
              value: yr.project_code,
            })),
          ]}
          popupMatchSelectWidth={false}
          tagRender={(v) => <span className="text-[#1C4E9D]">{v.label}</span>}
          onChange={(val) =>
            handleChange(
              val,
              setSelectedProjectsCodeWithoutQuarterly,
              projectListDataWithoutQuarterly.map((v) => v.project_code),
            )
          }
          maxTagPlaceholder={(omittedValues) =>
            selectedProjectsCodeWithoutQuarterly.includes('all') ? null : (
              <Tooltip
                styles={{
                  root: {
                    pointerEvents: 'none',
                  },
                }}
                title={omittedValues.map(({ label }) => label).join(', ')}
              >
                <span className="ml-1">{omittedValues.length}+</span>
              </Tooltip>
            )
          }
        />
      </div>

      {/* .........................Project Name........................................................ */}
      <div className="bg-white rounded-md text-[#1C4E9D] font-medium px-1 py-1 text-xs xl:text-sm font-['SF-Pro-Text-Regular, sans-serif']">
        <Select
          placeholder="Project Name"
          loading={projectListLoading || projectListLoadingWithoutQuarterly}
          variant="borderless"
          mode="multiple"
          style={{ width: '100%' }}
          maxTagCount={1}
          showSearch
          filterOption={(input, option) => {
            return String(option?.label)
              .toLowerCase()
              .includes(String(input).toLowerCase());
          }}
          // onSearch={(v) => handleSearch(v, getProjectList)}
          value={selectedProjectsName}
          options={
            selectedProjectsCode.filter((v) => v !== 'all').length ||
            selectedProjectsCodeWithoutQuarterly.filter((v) => v !== 'all')
              .length
              ? [
                  { label: 'All', value: 'all' },
                  ...loadProjectNames.map((yr) => ({
                    label: `${yr.project_name} (${yr.project_code})`,
                    value: yr.project_code,
                  })),
                ]
              : [
                  { label: 'All', value: 'all' },
                  ...[
                    ...projectListData,
                    ...projectListDataWithoutQuarterly,
                  ].map((yr) => ({
                    label: `${yr.project_name} (${yr.project_code})`,
                    value: yr.project_code,
                  })),
                ]
          }
          popupMatchSelectWidth={false}
          tagRender={(v) => <span className="text-[#1C4E9D]">{v.label}</span>}
          onChange={(val) =>
            handleChange(
              val,
              setSelectedProjectsName,
              selectedProjectsCode.filter((v) => v !== 'all').length ||
                selectedProjectsCodeWithoutQuarterly.filter((v) => v !== 'all')
                  .length
                ? loadProjectNames.map((v) => v.project_code)
                : [...projectListData, ...projectListDataWithoutQuarterly].map(
                    (v) => v.project_code,
                  ),
            )
          }
          maxTagPlaceholder={(omittedValues) =>
            selectedProjectsName.includes('all') ? null : (
              <Tooltip
                styles={{
                  root: {
                    pointerEvents: 'none',
                  },
                }}
                title={omittedValues.map(({ label }) => label).join(', ')}
              >
                <span className="ml-1">{omittedValues.length}+</span>
              </Tooltip>
            )
          }
        />
      </div>
    </div>
  );
}
